export const getStatus = (inspectionDate, expiryDate) => {
  const today = new Date();
  const expiry = new Date(expiryDate);

  const diffDays = Math.ceil(
    (expiry - today) / (1000 * 60 * 60 * 24)
  );

  if (diffDays < 0) {
    return { text: "Expired", className: "bg-danger" };
  }

  if (diffDays <= 30) {
    return { text: "Expiring Soon", className: "bg-warning" };
  }

  return { text: "Valid", className: "bg-success" };
};